import { ChangeDetectionStrategy, Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mcrai-dt',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-dt{display:block;font-size:14px}`],
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DescListTermComponent implements OnInit {
  readonly DESC_LIST_TERM_CLASS = 'mcrai-dt';

  constructor(
    private _renderer: Renderer2,
    private _elRef: ElementRef
  ) { }

  ngOnInit() {
    this._renderer
      .addClass(this._elRef.nativeElement, this.DESC_LIST_TERM_CLASS);
  }

}
